import { Row, Col } from 'react-bootstrap';
const Footer = ({ address = '', phone = '', email = '', hours = '' }) => {
  return (
    <footer className="footer">
      <section className="footer__info ">
        <div className="footer__container">
          <Row>
            <Col>
              <div className="footer__info-item">
                <strong className="footer__info-label ">Located at:</strong>
                <a className="footer__link" href="https://goo.gl/maps/TNd8KdyAs1hhBkbRA">
                  {address}
                </a>
              </div>
            </Col>
            <Col>
              <div className="footer__info-item">
                <strong className="footer__info-label ">Phone:</strong>
                <a className="footer__link" href={`tel:+${phone}`}>
                  {phone}
                </a>
              </div>
            </Col>
            <Col>
              <div className="footer__info-item">
                <strong className="footer__info-label ">Email:</strong>
                <a className="footer__link" href={`mailto:${email}`}>
                  {email}
                </a>
              </div>
            </Col>
            <Col>
              <div className="footer__info-item">
                <strong className="footer__info-label ">Hours:</strong>
                <p>Monday - Friday:</p>
                <p>{hours}</p>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </footer>
  );
};
export default Footer;
